import { getReportFooter, getReportHeader } from "@/reports/ReportUtil";
import { styles } from "@/reports/reportStyles";
import { useConfigStore } from "@/stores/config";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useInspectionStore } from "@/stores/inspection";
import { fatigueDetail } from "@/composables/NSTMFatigueData";
import { getNSTMFatigueDocDefinition } from "@/reports/NSTMDetailsTable";

function setNSTMFatigueDocDefinition(structure) {
  const configStore = useConfigStore();
  const SpanSet = [];
  SpanSet.push(getSpanSetHeader());
  getSpanSetDetails(SpanSet, structure);

  let docDefinition = {
    header: function () {
      return getReportHeader("NSTM/Fatigue Page", structure);
    },
    footer: function (currentPage, pageCount) {
      return getReportFooter(currentPage, pageCount);
    },
    pageMargins: [20, 70, 20, 50],
    content: [
      { text: "", pageHeaderText: "NSTM/Fatigue Page" },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "NSTM Conditions",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
                margin: [0, 3, 0, 2],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 5, 0, 0],
      },
      {
        columns: [
          {
            text: "B.C.14 NSTM Inspection Condition: ",
            bold: true,
            width: "30%",
            margin: [5, 5, 0, 0],
          },
          {
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.CONDITION_RATING,
              getNSTMInspectionCondition(structure)
            ),
            width: "*",
            margin: [0, 5, 0, 0],
          },
        ],
      },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "General Information",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
                margin: [0, 3, 0, 2],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 5, 0, 0],
      },
      {
        columns: [
          [
            {
              table: {
                headerRows: 1,
                widths: ["*", "99%", "*"],
                body: [
                  [
                    {},
                    {
                      colSpan: 1,
                      text: "Plug Weld Indicator",
                      fillColor: "#ebebeb",
                      alignment: "center",
                      style: ["sectionHeader"],
                    },
                    {},
                  ],
                ],
              },
              layout: "noBorders",
              margin: [0, 5, 0, 0],
            },
          ],
          [
            {
              table: {
                headerRows: 1,
                widths: ["*", "99%", "*"],
                body: [
                  [
                    {},
                    {
                      colSpan: 1,
                      text: "Estimated Truck Traffic",
                      fillColor: "#ebebeb",
                      alignment: "center",
                      style: ["sectionHeader"],
                    },
                    {},
                  ],
                ],
              },
              layout: "noBorders",
              margin: [0, 5, 0, 0],
            },
          ],
        ],
      },
      {
        columns: [
          [
            [
              {
                table: {
                  headerRows: 0,
                  widths: ["*", "60%", "39%", "*"],
                  body: [
                    [
                      {},
                      {
                        colSpan: 1,
                        bold: true,
                        text: "NF.01 Superstructure: ",
                        margin: [0, 2, 0, 2],
                      },
                      {
                        colSpan: 1,
                        text: configStore.getReferenceValue(
                          REFERENCE_TABLE.PLUG_WELD_PROBLEM_TYPE,
                          structure?.userBridge?.supProblemType
                        ),
                        margin: [0, 2, 0, 2],
                      },
                      {},
                    ],
                    [
                      {},
                      {
                        colSpan: 1,
                        bold: true,
                        text: "NF.02 Substructure: ",
                        margin: [0, 2, 0, 2],
                      },
                      {
                        colSpan: 1,
                        text: configStore.getReferenceValue(
                          REFERENCE_TABLE.PLUG_WELD_PROBLEM_TYPE,
                          structure?.userBridge?.subProblemType
                        ),
                        margin: [0, 2, 0, 2],
                      },
                      {},
                    ],
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
          [
            [
              {
                table: {
                  headerRows: 0,
                  widths: ["*", "60%", "39%", "*"],
                  body: [
                    [
                      {},
                      {
                        colSpan: 1,
                        bold: true,
                        text: "NF.03 Cumulative Truck Traffic: ",
                        margin: [0, 2, 10, 2],
                      },
                      {
                        colSpan: 1,
                        text: structure?.userBridge?.estTruckTraffic,
                        margin: [10, 2, 0, 2],
                      },
                      {},
                    ],
                    [
                      {},
                      {
                        colSpan: 1,
                        bold: true,
                        text: "NF.04 Cumulative Truck Traffic for Fatigue Damage: ",
                        margin: [0, 2, 10, 2],
                      },
                      {
                        colSpan: 1,
                        text: structure?.userBridge?.estCumFatigLife,
                        margin: [10, 2, 0, 2],
                      },
                      {},
                    ],
                    [
                      {},
                      {
                        colSpan: 1,
                        bold: true,
                        text: "NF.05 Year of Estimate: ",
                        margin: [0, 2, 10, 2],
                      },
                      {
                        colSpan: 1,
                        text: structure?.userBridge?.estTruckTrafficYear,
                        margin: [10, 2, 0, 2],
                      },
                      {},
                    ],
                  ],
                },
                layout: "noBorders",
                margin: [0, 5, 0, 0],
              },
            ],
          ],
        ],
      },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "NSTM Details",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
                margin: [0, 3, 0, 2],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 5, 0, 0],
      },
      {
        table: {
          headerRows: 1,
          widths: ["14%", "13%", "14%", "14%", "15%", "14%", "10%"],
          body: SpanSet,
        },
        margin: [0, 5, 0, 5],
      },
      {
        margin: [0, 5, 0, 10],
        layout: "noBorders",
        table: {
          headerRows: 0,
          widths: ["25%", "25%", "25%", "25%"],
          border: false,
          body: [
            [
              {
                text: "NF.06 Redundancy: ",
                bold: true,
                width: "18%",
                margin: [0, 2, 0, 2],
              },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.REDUNDANCY,
                  structure?.userInspection?.redundancy || ""
                ),
                width: "32%",
                margin: [0, 2, 0, 2],
              },
              {
                text: "NF.07 NSTM's? ",
                bold: true,
                width: "24%",
                margin: [1, 2, 0, 2],
              },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.NSTM_PRESENT,
                  structure?.userInspection?.nstmPresent
                ),
                width: "*",
                margin: [0, 2, 0, 2],
              },
            ],
            [
              {
                text: "B.IR.02 Fatigue Details: ",
                bold: true,
                width: "18%",
                margin: [0, 2, 0, 2],
              },
              {
                text: configStore.getReferenceValue(REFERENCE_TABLE.FATIGUE_DETAILS, fatigueDetail()),
                width: "32%",
                margin: [0, 2, 0, 2],
              },
              {
                text: "B.IR.04 Complex Feature? ",
                bold: true,
                width: "24%",
                margin: [1, 2, 0, 2],
              },
              {
                text: configStore.getReferenceValue(
                  REFERENCE_TABLE.COMPLEX_FEATURE,
                  structure?.userInspection?.complexFeaturePresent
                ),
                width: "*",
                margin: [0, 2, 0, 2],
              },
            ],
          ],
        },
      },
      getNSTMFatigueDocDefinition(),
    ],
    styles: styles,
    defaultStyle: {
      fontSize: 10,
    },
  };
  return docDefinition;
}

function getSpanSetHeader() {
  return [
    {
      text: "B.SP.01\nSpan Config. Designation",
      style: ["tableHeader"],
    },
    {
      text: "SP.02\n Main Span Set Ind",
      style: ["tableHeader"],
    },
    {
      text: "B.SP.04\n Span Material",
      style: ["tableHeader"],
    },
    {
      text: "B.SP.05\n Span Continuity",
      style: ["tableHeader"],
    },
    {
      text: "B.SP.06\n Span Type",
      style: ["tableHeader"],
    },
    {
      text: "B.SP.07\n Span Prot. System",
      style: ["tableHeader"],
    },
    {
      text: "SP.03\n Group",
      style: ["tableHeader"],
    },
  ];
}

function getSpanSetDetails(SpanSet, structure) {
  const configStore = useConfigStore();

  const spans = mapSpanSetFields(
    structure.structureUnitSpanSets?.filter(
      (s) =>
        s.spanConfigDesignation?.startsWith("M") ||
        s.spanConfigDesignation?.startsWith("A") ||
        s.mainSpanSetIndicator === "Y"
    ) ?? []
  );

  for (const detail of spans ?? []) {
    SpanSet.push([
      detail?.spanConfigDesignation,
      {
        text: configStore.getReferenceValue(REFERENCE_TABLE.MAIN_SPANSET_INDICATOR, detail?.mainSpanSetIndicator),
        style: ["tableBody"],
      },
      {
        text: configStore.getReferenceValue(REFERENCE_TABLE.SPAN_MATERIAL, detail?.spanMaterial),
        style: ["tableBody"],
      },
      {
        text: configStore.getReferenceValue(REFERENCE_TABLE.SPAN_CONTINUITY, detail?.spanContinuity),
        style: ["tableBody"],
      },
      {
        text: configStore.getReferenceValue(REFERENCE_TABLE.SPAN_TYPE, detail?.spanType),
        style: ["tableBody"],
      },
      {
        text: configStore.getReferenceValue(REFERENCE_TABLE.SPAN_PROTECTION_SYSTEM, detail?.spanProtectSystem),
        style: ["tableBody"],
      },
      {
        text: detail?.nstmGroupNumber,
        style: ["tableBody"],
      },
    ]);
  }
}

function getNSTMInspectionCondition(structure) {
  const inspectionStore = useInspectionStore();
  if (!structure.userInspection.nstmCondition && !inspectionStore.getNstmInspectionConditionChangedByUser) {
    if (structure.userBridge.mainFCGroupNum < 5 || structure.userBridge.apprFCGroupNum < 5) {
      return structure.inspection.supRating;
    } else {
      return "N";
    }
  } else {
    return structure.userInspection.nstmCondition;
  }
}

function mapSpanSetFields(spans) {
  return spans
    .map((item) => ({
      spanConfigDesignation: item.spanConfigDesignation,
      mainSpanSetIndicator: item.mainSpanSetIndicator,
      spanMaterial: item.spanMaterial,
      spanContinuity: item.spanContinuity,
      spanType: item.spanType,
      spanProtectSystem: item.spanProtectSystem,
      nstmGroupNumber: item.nstmGroupNumber,
    }))
    .sort((a, b) => {
      const aIsM = a.spanConfigDesignation?.startsWith("M");
      const bIsM = b.spanConfigDesignation?.startsWith("M");

      if (aIsM && !bIsM) return -1; // M before A
      if (!aIsM && bIsM) return 1; // A after M

      // Extract numeric part for comparison
      const aNum = Number.parseInt(a.spanConfigDesignation?.slice(1), 10) || 0;
      const bNum = Number.parseInt(b.spanConfigDesignation?.slice(1), 10) || 0;

      return aNum - bNum;
    });
}

export { setNSTMFatigueDocDefinition };
